import CanvasMarkersLayer from './components/CanvasMarkersLayer';

export default CanvasMarkersLayer;